/**
 * @module store/getters
 * @category Gerenciador de estados
 * @summary Módulo de _getters_ do estado do sistema.
 *
 * @requires module:utils/array.findByObjectProp
 */
import { findByObjectProp } from "../utils/array";

/**
 * Obtém os metadados de um módulo. O método busca no _Array_ de metadados
 * de módulos a partir de um filtro de busca.
 * @function
 * @param {string} propName - Nome da propriedade utilizada como filtro de
 * busca.
 * @param {*} propValue - Valor da propriedade utilizada como filtro de busca.
 * @returns {object} Primeiro elemento do _Array_ cujo filtro de busca foi
 * satisfeito.
 */
export const getModuloMetadata = function(state) {
  return function(propertyName, propertyValue) {
    return findByObjectProp(state.modulos, propertyName, propertyValue);
  };
};

/**
 * Obtém o módulo já baixado. O método busca no _Array_ de módulos baixados a
 * partir de um filtro de busca.
 * @function
 * @param {string} propName - Nome da propriedade utilizada como filtro de
 * busca.
 * @param {*} propValue - Valor da propriedade utilizada como filtro de busca.
 * @returns {object} Primeiro elemento do _Array_ cujo filtro de busca foi
 * satisfeito.
 */
export const getDownloadedModulo = function(state) {
  return function(propertyName, propertyValue) {
    return (state.downloadedModulos || []).find(
      item => item && item[propertyName] === propertyValue
    );
  };
};

/**
 * Indica se um módulo já foi baixado. O método busca no _Array_ de módulos
 * baixados a partir de um filtro de busca.
 * @function
 * @param {string} propName - Nome da propriedade utilizada como filtro de
 * busca.
 * @param {*} propValue - Valor da propriedade utilizada como filtro de busca.
 * @returns {boolean} Valor indicando se o filtro foi satisfeito ou não.
 */
export const isModuloDownloaded = function(state) {
  return function(propertyName, propertyValue) {
    return (state.downloadedModulos || []).some(
      item => item && item[propertyName] === propertyValue
    );
  };
};

/**
 * Indica se um item de menu de um módulo já foi adicionado.
 * @function
 * @param {object} menuItem - Item de menu a ser buscado.
 * @returns {boolean} Valor indicando se o item de menu já foi adicionado ou
 * não.
 */
export const hasModuloMenuItem = function(state) {
  return function(menuItem) {
    let index = -1;

    if (menuItem.isLink) {
      index = state.moduloMenu.findIndex(
        item => item.isLink && item.content === menuItem.content
      );
    } else {
      const { to, content } = menuItem;

      index = state.moduloMenu.findIndex(item => {
        if (item.isLink) {
          return item.content === content;
        }

        if (to.name) {
          return item.to.name === to.name;
        } else if (to.path) {
          return item.to.path === to.path;
        }

        return content === item.content;
      });
    }

    return index !== -1;
  };
};
